export default __webpack_public_path__ + "static/media/trace_instaprof.d2864264.svg";